export default function(form, response, errorKeyToFieldMapping = {}) {
  response.graphQLErrors.forEach(({ details }) => {
    if (!details) {
      return;
    }

    Object.keys(details).forEach((key) => {
      const fields = errorKeyToFieldMapping[key] || key;
      if (Array.isArray(fields)) {
        handleArrayOfFields(form, fields, key, details);
      } else {
        setErrorsToField(form, fields, form.getFieldValue(fields), getErrors(details, key))
      }
    })
  })
};

function handleArrayOfFields(form, fields, key, details) {
  fields.forEach((field) => {
    if (Array.isArray(form.getFieldValue(key))) {
      form.getFieldValue(key).forEach((item, index) => {
        const value = `${key}[${index}].${field}`;
        if (details[key][0][index]) {
          details[key][0][index].forEach((errorDetails) => {
            setErrorsToField(form, value, form.getFieldValue(value), getErrors(errorDetails, field))
          });
        }
      });
    } else {
      const value = `${key}.${field}`;
      details[key].forEach((errorDetails) => {
        setErrorsToField(form, value, form.getFieldValue(value), getErrors(errorDetails, field))
      });
    }
  });
}

function getErrors(details, key) {
  if (Array.isArray(details[key])) {
    return details[key].map((errorData) => new Error(errorData.message));
  } else {
    return [new Error(details.message)];
  }
}

function setErrorsToField(form, field, value, errors) {
  form.setFields({
    [field]: {
      value: value,
      errors: errors
    }
  });
}



// WEBPACK FOOTER //
// ./src/utilities/form/display_server_errors.js